// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","feedbackWrapper":"feedback_feedbackWrapper__F5Kb0","feedback":"feedback_feedback__J7NAQ"};